// Program Landsites page — PLACEHOLDER CONTENT.
// The structure and layout are final; site names, acreage, and descriptions
// below are illustrative and should be replaced with real landsite details.
// All imagery is real World Farmers photography from /images/wf/.

export const LANDSITES_HERO = {
  eyebrow: "Program landsites",
  title: "Where our farmers grow",
  lede:
    "From the river-bottom fields of the Flats Mentor Farm to partner sites across Massachusetts, every landsite gives farmers the ground, water, and infrastructure to build a business of their own.",
  image: "/images/wf/farm-007.jpg",
  imageAlt:
    "A wide shot of a person working in a sunny, expansive field with hoop houses in the background.",
};

export const LANDSITES_INTRO = {
  eyebrow: "Our land",
  title: "Land is the first thing a farmer needs",
  paragraphs: [
    "Access to land is the single greatest barrier for immigrant and refugee farmers. World Farmers secures, stewards, and equips farmland so that growers can focus on what they know best: farming.",
    "Each landsite is managed with shared infrastructure \u2014 irrigation, wash stations, cold storage, and high tunnels \u2014 and supported by our on-site team of farm managers and sustainability coordinators.",
  ],
  stats: [
    { id: "sites", value: "4", label: "Active landsites" },
    { id: "acres", value: "55+", label: "Acres in production" },
    { id: "tunnels", value: "9", label: "High tunnels" },
  ],
};

// PLACEHOLDER landsite cards.
export const LANDSITES = [
  {
    id: "flats-mentor-farm",
    name: "Flats Mentor Farm",
    town: "Lancaster, MA",
    acres: "70 acres",
    status: "Flagship site",
    body:
      "Our flagship river-bottom parcel along the Nashua River, home to the mentorship program since 1984. Shared irrigation, wash-pack facilities, and nine high tunnels.",
    features: ["Irrigation", "High tunnels", "Wash & pack", "Cold storage"],
    image: "/images/wf/vlai/vlai-3875.jpg",
    alt: "A large hoop house stands beside rows of crops under a blue summer sky.",
    href: "/programs/flats-mentor-farm",
    placeholder: false,
  },
  {
    id: "sutton",
    name: "Sutton Farm Site",
    town: "Sutton, MA",
    acres: "Acreage TBD",
    status: "Details coming soon",
    body:
      "Placeholder description. A newer growing site expanding land access for farmers in Worcester County. Details on acreage, infrastructure, and farmer plots will be added here.",
    features: ["Field plots", "Irrigation"],
    image: "/images/wf/vlai/vlai-3579.jpg",
    alt: "A farmer bends low to harvest from a row of leafy plants.",
    href: null,
    placeholder: true,
  },
  {
    id: "partner-site-1",
    name: "Partner Landsite",
    town: "Central Massachusetts",
    acres: "Acreage TBD",
    status: "Details coming soon",
    body:
      "Placeholder description. Land made available through a conservation or municipal partnership, supporting farmers moving toward independent operations.",
    features: ["Field plots"],
    image: "/images/wf/vlai/vlai-3810.jpg",
    alt: "A black-and-white portrait of a farmer in a wide-brimmed hat tending crops.",
    href: null,
    placeholder: true,
  },
  {
    id: "partner-site-2",
    name: "Partner Landsite",
    town: "Eastern Massachusetts",
    acres: "Acreage TBD",
    status: "Details coming soon",
    body:
      "Placeholder description. A market-adjacent growing site that shortens the distance between farmers and the communities they feed.",
    features: ["Field plots", "Market access"],
    image: "/images/wf/vlai/vlai-3828.jpg",
    alt: "A farmer loads a wheelbarrow with bagged greens at the edge of the field.",
    href: null,
    placeholder: true,
  },
];

export const LANDSITES_STEWARDSHIP = {
  eyebrow: "Stewardship",
  title: "Farming that protects the land it depends on",
  body:
    "Every World Farmers landsite follows sustainable production practices \u2014 cover cropping, soil health monitoring, integrated pest management, and careful water use \u2014 so the land stays productive for the next generation of farmers.",
  points: [
    "Soil fertility and cover-crop planning for every plot",
    "Efficient drip irrigation and water conservation",
    "Integrated pest and weed management with minimal spraying",
    "Flood-resilience planning informed by the 2021 and 2023 floods",
  ],
  image: "/images/wf/farm-91.jpg",
  imageAlt:
    "A farmer sitting on a small stool while working in a field with a wooden trellis structure behind.",
};

export const LANDSITES_CTA = {
  eyebrow: "Grow with us",
  title: "Have land to share, or want to farm with us?",
  body:
    "We partner with landowners, towns, and conservation groups to bring more acres into production \u2014 and we welcome farmers from every corner of the globe.",
  primary: { label: "Contact us", href: "/contact" },
  secondary: { label: "Explore the mentorship path", href: "/programs/mentorship" },
};
